export default __webpack_public_path__ + "images/125c5d4f32eb04d3624562605dcfe081-x-blue.svg";